import { Grid } from '@mui/material';

import { useFormikContext } from 'formik';

import { JobOfferItem } from 'app/components/RichList/items/JobOfferItem';
import { JobOffering, JobPeriod } from 'types/AppTypes';

import { JobOffersOverview } from '../../JobOffers';

const SelectJobOffer = () => {
  const { values, setFieldValue } = useFormikContext<{
    jobOffering: JobOffering & { jobPeriods: JobPeriod[] };
  }>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JobOffersOverview
          renderTile={jobOffer => (
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              className="joboffer"
              onClick={() => {
                setFieldValue('jobOffering', {
                  ...jobOffer,
                  jobPeriods: jobOffer.jobPeriods.filter(
                    jp => !jp.isCanceled && new Date(jp.endDate) > new Date()
                  )
                });
                setFieldValue('jobPeriodIds', []);
              }}
            >
              <JobOfferItem
                key={jobOffer.id}
                jobOffer={jobOffer}
                dense
                selected={values?.jobOffering?.id === jobOffer.id}
                hideCourses
              />
            </Grid>
          )}
        />
      </Grid>
    </Grid>
  );
};

export default SelectJobOffer;
